// extracted by mini-css-extract-plugin
module.exports = {"wrap":"allotModel_wrap_3U-vT","title":"allotModel_title_3-3wf"};